<template>
    <div>
        <section class="section--alt has-bottom-image">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div class="block">
                            <div class="row">
                                <img
                                    class="icon--simtoool col-4"
                                    src="../assets/images/icon_simtool.png"
                                />
                                <div class="col-8">
                                    <h1>{{ $t('account.login.title') }}</h1>
                                    <p>{{ $t('account.login.sub_title') }}</p>
                                </div>
                            </div>
                            <form class="form--rounded" @submit.prevent="login">
                                <div class="row is-full-width">
                                    <form-input
                                        class="col-12"
                                        v-model="form"
                                        name="email"
                                        :placeholder="$t('account.form.email')"
                                        autocomplete="username"
                                    />
                                    <form-input
                                        class="col-12"
                                        v-model="form"
                                        name="password"
                                        :placeholder="$t('account.form.password')"
                                        type="password"
                                        autocomplete="current-password"
                                    />

                                    <p
                                        class="col-12 small"
                                        v-html="
                                            $t('account.form.communication_consent_explanation')
                                        "
                                    ></p>
                                    <checkbox
                                        class="col-12"
                                        id="communication_consent"
                                        name="communication_consent"
                                        v-model="form"
                                    >
                                        {{ $t('account.form.communication_consent_label') }}
                                    </checkbox>
                                    <input
                                        id="simtool_log_in"
                                        type="submit"
                                        class="button--primary button--rounded is-full-width"
                                        :value="$t('account.login.login')"
                                    />
                                </div>
                            </form>
                            <p class="text-center">
                                {{ $t('account.form.no_account') }}
                                <router-link
                                    :to="{ name: 'SignUp' }"
                                    id="simtool_no_account_signup"
                                >
                                    {{ $t('account.signup.signup') }}
                                </router-link>
                            </p>
                            <p class="text-center">
                                <router-link
                                    :to="{ name: 'PasswordReset' }"
                                    id="simtool_forgot_my_password"
                                >
                                    {{ $t('account.passwordforget.passwordforget') }}
                                </router-link>
                            </p>
                        </div>
                        <p class="text-center">
                            {{ $t('account.form.privacy_before_login') }}
                            <a href="https://www.tecnotion.com/privacy-statement" target="_blank">
                                {{ $t('account.form.privacy_middle') }}
                            </a>
                            {{ $t('account.form.privacy_after') }}
                        </p>
                    </div>
                </div>
            </div>
            <img class="section__bottom_image" src="./../assets/images/tecnotion.png" />
        </section>
        <EndSignUpMail />
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import FormInput from '@/components/FormInput';
import Checkbox from '@/components/Checkbox';
import EndSignUpMail from '@/components/EndSignUpMail';
import { SET_AUTH_TOKEN } from '../store/types';

@Component({
    components: {
        FormInput,
        Checkbox,
        EndSignUpMail,
    },
})
export default class Login extends Vue {
    loading = false;

    form = {
        email: { value: null, error: '' },
        password: { value: null, error: '' },
        communication_consent: { value: null, error: '' },
        hubspotutk: { value: null, error: '' },
    };

    emailPattern = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    async login() {
        this.error = '';

        if (!this.validate()) {
            return;
        }

        try {
            this.loading = true;
            let data = {};
            for (let param in this.form) {
                data[param] = this.form[param].value;
            }

            var match = document.cookie.match(new RegExp('hubspotutk' + '=([^;]+)'));
            if (match) data.hubspotutk = match[1];
            else data.hubspotutk = '';

            match = document.cookie.match(new RegExp('__hstc' + '=([^;]+)'));
            if (match) data.__hstc = match[1];
            else data.__hstc = '';

            match = document.cookie.match(new RegExp('__hssc' + '=([^;]+)'));
            if (match) data.__hssc = match[1];
            else data.__hssc = '';

            const response = await Vue.api.post('/login').send(JSON.stringify(data));
            this.$store.commit(SET_AUTH_TOKEN, response);
            if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect);
            } else {
                this.$router.push({ name: 'Dashboard' });
            }
        } catch (e) {
            const errors = await e.json();
            for (let field in errors) {
                if (this.form[field]) {
                    Vue.set(this.form[field], 'error', errors[field]);
                }
            }
        } finally {
            this.loading = false;
        }
    }

    validate() {
        this.reset_form_error();

        if (!this.form.email.value || !this.emailPattern.test(this.form.email.value)) {
            Vue.set(this.form.email, 'error', this.$i18n.t('account.errors.not_valid_email'));
        }
        if (!this.form.password.value) {
            Vue.set(
                this.form.password,
                'error',
                this.$i18n.t('account.errors.password_not_filled_in'),
            );
        }

        return Object.keys(this.form).every(field => !this.form[field].error);
    }

    reset_form_error() {
        Object.keys(this.form).forEach(key => (this.form[key].error = ''));
    }
}
</script>
